import React from "react";

function FormatUpTo3Decimals(num) {
  if (typeof num !== "number") return num;
  if (Number.isInteger(num)) return num;
  return parseFloat(num.toFixed(3));
}

export const MetaCampaignDataTableHeader = [
  {
    id: 1,
    label: "Sync date",
    input: "syncDate",
    isSortable: false,
    component: (data) => {
      let dateStr = "-";
      let timeStr = "-";
      if (data.syncDate) {
        const d = new Date(data.syncDate);
        if (!isNaN(d)) {
          const day = String(d.getDate()).padStart(2, "0");
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const year = d.getFullYear();
          dateStr = `${day}/${month}/${year}`;
          let hours = d.getHours();
          const minutes = String(d.getMinutes()).padStart(2, "0");
          const seconds = String(d.getSeconds()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12;
          hours = hours ? hours : 12;
          timeStr = `${String(hours).padStart(
            2,
            "0"
          )}:${minutes}:${seconds} ${ampm}`;
        }
      }
      return (
        <span>
          <div>{dateStr}</div>
          <div style={{ color: "#8E8E93" }}>{timeStr}</div>
        </span>
      );
    },
  },
  {
    id: 2,
    label: "Status",
    input: "syncStatus",
    isSortable: false,
    component: (data) => {
      const status = data?.syncStatus ?? "Success";
      return (
        <span
          style={{ color: status.toLowerCase() === "success" ? "#1db954" : "#e53935" }}
        >
          {status}
        </span>
      );
    },
  },
  {
    id: 3,
    label: "Daily budget",
    input: "totalDailyBudget",
    isSortable: false,
    component: (data) => {
      if (!data.totalDailyBudget) return "-";
      return `AED ${FormatUpTo3Decimals(data.totalDailyBudget)}`;
    },
  },
  {
    id: 4,
    label: "Total spend",
    input: "totalSpent",
    isSortable: false,
    component: (data) => {
      if (!data.totalSpent) return "-";
      return `AED ${FormatUpTo3Decimals(data.totalSpent)}`;
    },
  },
  {
    id: 5,
    label: "Total leads",
    input: "totalLeads",
    isSortable: false,
  },
  {
    id: 6,
    label: "Cost per lead",
    input: "costPerLead",
    isSortable: false,
    component: (data) => {
      if (data.totalLeads === 0 || data.totalLeads === "") return "_";
      return `AED ${FormatUpTo3Decimals(data.costPerLead)}`;
    },
  },
];
